module.exports = "/_next/static/images/get-started_26fbec857b42d7b0c5b62db4435b7ae7.png";